import { useState, useEffect } from 'react';
import { Grid, RadioGroup, FormControlLabel, Radio, Typography, Tooltip } from '@mui/material';
import { useCurrencyUnit } from 'hooks';
import AccountsSelectBox from '../AccountsSelectBox';
import { useStyles } from './style';
import { Icons, PriceLabel, NumberToPersianWords } from 'components';
import clsx from 'clsx';
import { RadioButtonIcon, RadioButtonIconFill } from 'components/CheckBox/RadioButtonIcon';

const WalletOrCredit = ({
  // if you wanna use guild value or something , call useForm in parent and pass methods in this component
  balance,
  methods,
  methodType,
  setMethodType,
  guildNameSerivece,
}) => {
  //STATES//
  const [walletAmount, setWalletAmount] = useState(balance?.customerAmountSrvs?.[0]?.amount);
  const currencyText = useCurrencyUnit(false);
  const classes = useStyles();

  useEffect(() => {
    setWalletAmount(balance?.customerAmountSrvs?.[0]?.amount);
  }, [balance]);

  return (
    <Grid container spacing={0}>
      <Grid item xs={12} lg={6}>
        <RadioGroup
          style={{ marginTop: 8 }}
          row
          xs={12}
          required
          onChange={(e) => {
            setMethodType(e?.target?.value);
          }}
          value={methodType}
          defaultValue="wallet"
        >
          <Grid
            container
            xs={12}
            justifyContent="space-between"
            spacing={1}
            style={{ position: 'relative' }}
          >
            <Grid item xs={12} md={6}>
              <FormControlLabel
                value="wallet"
                className={clsx(classes.radioItem, {
                  active: methodType === 'wallet',
                })}
                control={
                  <Radio
                    className={classes.radioCircle}
                    icon={<RadioButtonIcon />}
                    checkedIcon={<RadioButtonIconFill />}
                  />
                }
                label={
                  <>
                    <span className={classes.radioIcon}>
                      <Icons icon="wallet" color="#2b3990" size="24" />
                    </span>
                    <Typography className={classes.radioText}>
                      حساب دیجیتال
                      <br />
                    </Typography>
                    <Tooltip
                      title="موجودی حساب دیجیتال شما هنگام خرید چک می‌شود."
                      className={classes.clickable}
                    >
                      <span className={classes.infoIcon}>
                        <Icons icon="Info" color="#2b3990" size="20" />
                      </span>
                    </Tooltip>
                  </>
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                value="credit"
                className={clsx(classes.radioItem, {
                  active: methodType == 'credit',
                })}
                control={
                  <Radio
                    className={classes.radioCircle}
                    icon={<RadioButtonIcon />}
                    checkedIcon={<RadioButtonIconFill />}
                  />
                }
                label={
                  <>
                    <span className={classes.radioIcon}>
                      <Icons icon="ShieldSuccess" color="#2b3990" size="24" />
                    </span>
                    <Typography className={classes.radioText}>حساب‌های تفصیلی</Typography>
                  </>
                }
              />
            </Grid>
          </Grid>
        </RadioGroup>
      </Grid>
      {methodType === 'wallet' && (
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <Grid
              container
              className={classes.balanceBox}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <Typography className={classes.balanceTitle}>موجودی حساب دیجیتال پاد</Typography>
                <Typography className={classes.balancePriceText}>
                  <NumberToPersianWords number={walletAmount} />
                </Typography>
              </Grid>
              <Grid item>
                <Typography className={classes.balancePrice}>
                  <PriceLabel amount={walletAmount} />
                  <span className={classes.currencyText}> {currencyText}</span>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      {methodType == 'credit' ? (
        <Grid container style={{ marginTop: 8, paddingLeft: '8px' }}>
          <Grid item xs={12} md={6}>
            <AccountsSelectBox
              methods={methods}
              name="guildCode"
              label={'حساب تفصیلی مبدا (از حساب)'}
              singleSelect={true}
              rules={['required']}
              disableNoBalances
              serviceName={guildNameSerivece}
              balance={balance}
              currencyText={currencyText}
            />
          </Grid>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default WalletOrCredit;
